import { MailInboxDTO } from "../../models/mail-inbox/mail-inbox-dto";
import { MailInboxSTO } from "../../models/mail-inbox/mail-inbox-sto";
import { BaseApiService } from "../base";

export class MailInboxApiService extends BaseApiService<MailInboxDTO, MailInboxSTO> {
  constructor() {
    super({
      servicePath: "/MailInbox",
      loadItemsPath: "/GetMailInboxes",
      saveItemsPath: "/SaveMailInboxes",
    });
  }
}
